import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const stats = [
  { number: '500万+', label: '月活跃吃瓜群众' },
  { number: '12万+', label: '累计吃瓜文章' },
  { number: '50万+', label: '日均互动评论' },
  { number: '365天', label: '全年无休更新' },
];

const testimonials = [
  {
    quote: '自从关注了51吃瓜大赛，我再也不担心错过任何娱乐圈大瓜了！每天打开网站就有最新爆料，上班摸鱼必备。',
    name: '资深吃瓜人',
    platform: '微博用户',
  },
  {
    quote: '51吃瓜大赛的爆料速度真是太快了，很多热门事件都是在这里先看到的，比其他平台快好几个小时。',
    name: '追瓜小能手',
    platform: '知乎用户',
  },
  {
    quote: '内容真实度高，不会瞎编乱造，每个爆料都有据可查。作为一个理性吃瓜人，这里是我最信任的吃瓜平台。',
    name: '理性吃瓜群众',
    platform: '豆瓣用户',
  },
];

const faqData = [
  {
    question: '51吃瓜大赛是什么？',
    answer: '51吃瓜大赛是一个专注于娱乐资讯聚合的内容平台，每日更新网红塌房、明星黑料、热门大赛等吃瓜内容。我们致力于为广大网民提供最新、最全、最真实的吃瓜资讯，让你不错过任何一个大瓜。',
  },
  {
    question: '51吃瓜大赛的内容来源是什么？',
    answer: '我们的内容来源于多渠道信息采集，包括社交媒体监测、网友投稿、行业爆料等。所有内容均经过编辑团队审核确认后方可发布，确保信息的真实性和可靠性。',
  },
  {
    question: '如何第一时间获取最新吃瓜资讯？',
    answer: '你可以直接访问51吃瓜大赛网站首页，我们会实时更新最新爆料。此外，你也可以关注我们的社交媒体账号（微博、微信公众号、抖音等），获取最新的推送通知。',
  },
  {
    question: '51吃瓜大赛的内容是否免费？',
    answer: '是的！51吃瓜大赛的所有内容完全免费开放。我们相信吃瓜是每个人的基本权利，任何人都可以随时随地访问我们的平台，畅享最新吃瓜资讯。',
  },
  {
    question: '如何在51吃瓜大赛投稿或爆料？',
    answer: '如果你有独家爆料或精彩的吃瓜内容想要分享，可以通过我们的社交媒体私信或发送邮件至投稿邮箱进行投稿。我们的编辑团队会在24小时内审核并回复。',
  },
];

export default function AboutPage() {
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51吃瓜大赛',
    url: 'https://www.51chigua.com',
    description: '51吃瓜大赛中心，汇聚51吃瓜网站、51吃瓜在线观看入口，每日更新黑料吃瓜爆料，追踪网红塌房、明星黑料、热门大赛。',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@51chigua.com',
      availableLanguage: ['Chinese'],
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.51chigua.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.51chigua.com/about' },
    ],
  };

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
        />

        <nav className="max-w-6xl mx-auto px-4 md:px-6 pt-6" aria-label="面包屑导航">
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800 font-medium">关于我们</span>
          </div>
        </nav>

        <section className="w-full py-10 md:py-16 bg-background-50">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-12 items-center">
              <div className="flex-1">
                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-medium mb-4">
                  <i className="ri-information-line"></i>
                  品牌介绍
                </span>
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-4">
                  关于51吃瓜大赛
                </h1>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  51吃瓜大赛成立于2024年，是国内领先的娱乐资讯聚合平台。我们专注于追踪网红塌房、明星黑料、热门大赛等精彩吃瓜内容，致力于为每一位吃瓜群众提供最新、最全、最真实的一手资讯。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  我们的编辑团队24小时全天候监测各大社交平台和娱乐圈动态，确保第一时间将热乎乎的"大瓜"送到你面前。无论你是资深吃瓜人还是吃瓜新手，51吃瓜大赛都是你的最佳信息源。
                </p>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                  {stats.map((stat) => (
                    <div key={stat.label} className="text-center p-3 rounded-lg bg-background-100">
                      <div className="text-lg md:text-xl font-heading font-bold text-primary-600">{stat.number}</div>
                      <div className="text-[11px] text-foreground-500 mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="lg:w-[420px] flex-shrink-0">
                <div className="rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20open%20newsroom%20with%20large%20digital%20screens%20displaying%20social%20media%20feeds%2C%20warm%20indirect%20lighting%2C%20editorial%20workspace%20with%20creative%20atmosphere%2C%20minimalist%20modern%20office%20design%2C%20clean%20white%20and%20wood%20tones%2C%20professional%20creative%20environment%2C%20high%20detail%20architectural%20photography&width=800&height=600&seq=about-brand-image&orientation=landscape"
                    alt="51吃瓜大赛编辑部工作场景"
                    className="w-full aspect-[4/3] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                <i className="ri-star-line"></i>
                用户口碑
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                吃瓜群众怎么说
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                来自真实用户的评价，你的满意是我们前进的动力
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((t) => (
                <div key={t.name} className="bg-background-50 rounded-xl p-6">
                  <div className="mb-4">
                    <i className="ri-double-quotes-l text-3xl text-primary-200"></i>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    {t.quote}
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                      <i className="ri-user-line text-primary-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.platform}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
                <i className="ri-question-line"></i>
                常见问题
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                吃瓜常见问题FAQ
              </h2>
            </div>

            <div className="space-y-4">
              {faqData.map((faq, index) => (
                <details key={index} className="group bg-background-100 rounded-xl">
                  <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                    <h3 className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                      {faq.question}
                    </h3>
                    <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-500 group-open:text-background-50 transition-all">
                      <i className="ri-add-line text-sm group-open:hidden"></i>
                      <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-foreground-900">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-background-50/60 mb-8">
              有独家爆料？广告合作？意见建议？欢迎随时联系我们
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
              <div className="bg-background-50/5 rounded-xl p-5">
                <div className="w-10 h-10 rounded-lg bg-primary-500/20 flex items-center justify-center mb-3 mx-auto">
                  <i className="ri-mail-line text-primary-400 text-lg"></i>
                </div>
                <div className="text-xs text-background-50/50 mb-1">投稿邮箱</div>
                <div className="text-sm text-background-50 font-medium">tips@51chigua.com</div>
              </div>
              <div className="bg-background-50/5 rounded-xl p-5">
                <div className="w-10 h-10 rounded-lg bg-accent-500/20 flex items-center justify-center mb-3 mx-auto">
                  <i className="ri-wechat-line text-accent-400 text-lg"></i>
                </div>
                <div className="text-xs text-background-50/50 mb-1">微信公众号</div>
                <div className="text-sm text-background-50 font-medium">51吃瓜大赛</div>
              </div>
              <div className="bg-background-50/5 rounded-xl p-5">
                <div className="w-10 h-10 rounded-lg bg-secondary-500/20 flex items-center justify-center mb-3 mx-auto">
                  <i className="ri-weibo-line text-secondary-400 text-lg"></i>
                </div>
                <div className="text-xs text-background-50/50 mb-1">微博账号</div>
                <div className="text-sm text-background-50 font-medium">@51吃瓜大赛</div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}